import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./automationDetailView.styl";
const template = require("./automationDetailView.vue");

@Component({
  template: template
})
export class AutomationDetailViewComponent extends Vue {


}

Vue.component("cmAutomationDetailView", AutomationDetailViewComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/automationDetailView/automationDetailView.ts